import {
  EventExceptionalClosingDateType,
  EventScheduleType,
  formatEventDate,
  getEventEndDate,
  getEventStartDate,
  toDatabaseFormat,
} from "@ac-expo/utils";
import { ArrowLeftIcon } from "@phosphor-icons/react";
import { Image } from "lucide-react";
import { cn, useIsSmallDevice } from "../../../utils";
import { CountdownBanner } from "./CountdownBanner";
import { EventThumbnail } from "./EventThumbnail";

type EventViewPictureProps = {
  thumbnailImageUrl: string;
  schedules: EventScheduleType[];
  exceptionalClosingDates: EventExceptionalClosingDateType[];
  isCountdownVisible: boolean;
  navigateBack?: () => void;
};

export function EventViewPictureCard({
  thumbnailImageUrl,
  schedules,
  exceptionalClosingDates,
  isCountdownVisible,
  navigateBack,
}: EventViewPictureProps) {
  const isSmallDevice = useIsSmallDevice();
  const startDate = getEventStartDate({ schedules, exceptionalClosingDates, isContinuous: false });
  const endDate = getEventEndDate({ schedules, exceptionalClosingDates, isContinuous: false });
  return (
    <div
      className={cn("size-full max-lg:px-2", {
        "rounded-3xl pt-10": !isSmallDevice,
        "pt-2": isSmallDevice,
      })}
    >
      <div
        className={cn(
          "relative w-full overflow-hidden bg-gray-200 lg:rounded-3xl aspect-[1280/486]",
        )}
      >
        {thumbnailImageUrl ? (
          <EventThumbnail
            imageUrl={thumbnailImageUrl}
            altContent="l'événement"
            className={cn("size-full")}
            objectFit="auto"
          />
        ) : (
          <div className="bg-secondary-50 relative size-full max-md:min-h-36 lg:rounded-xl">
            <Image
              className="text-secondary-300 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
              size={32}
            />
          </div>
        )}
        {isCountdownVisible && startDate && endDate && (
          <CountdownBanner
            startDate={toDatabaseFormat(startDate)}
            endDate={toDatabaseFormat(endDate)}
          />
        )}
        <button
          onClick={navigateBack}
          className="absolute left-4 top-4 z-50 rounded-lg bg-white p-2 shadow-md xl:hidden"
        >
          <ArrowLeftIcon size={20} />
        </button>
        <p className="absolute bottom-4 left-2 z-50 rounded-full bg-white px-2 text-sm text-gray-600 lg:hidden">
          {formatEventDate(schedules, exceptionalClosingDates)}
        </p>
      </div>
    </div>
  );
}
